import React, { Component } from 'react';
import { Row, Col, Table, Alert, Panel } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from '@fortawesome/fontawesome-free-solid'
import Loader from 'src/js/Loader.js';
import { msgs } from 'src/js/ErrorMessage.js';
import '../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'src/i18n';
import { withTranslation , Trans} from 'react-i18next';


class TripListTable extends Component {

  constructor() {
    super();

    this.state = {
      windowSize: window.parent.screen.width,
      pageIndex: 1
    };

    this.updateWindowSize = this.updateWindowSize.bind(this);
    this.isExpandableRow = this.isExpandableRow.bind(this);
  }

  // 画面サイズの更新
  updateWindowSize() {
    this.setState({ windowSize: window.parent.screen.width });
  }

  componentDidMount() {
    // 画面サイズ変更イベントを登録
    window.addEventListener("resize", this.updateWindowSize);
    // this.updateStyle();
  }

  componentWillUnmount() {
    // イベントを削除
    window.removeEventListener("resize", this.updateWindowSize);
  }

  // BootstrapTable行拡張許可
  isExpandableRow(row) {
    if (this.props.isLink) {
      return false;
    }
    return true;
  }

  // 行拡張で表示するデータ
  expandComponent(row) {
    // console.log(row)
    return (
      <Table className="expandTable">
        <tbody>
          <tr>
            <th>
              <Trans i18nKey="Common.Distance">
                Distance(km)
              </Trans>
            </th>
            <td>{row.distance ? parseInt(row.distance, 10) : 0}</td>
          </tr>
          <tr>
            <th>
              <Trans i18nKey="Common.Duration">
                Duration(min)
              </Trans>
            </th>
            <td>{row.duration ? parseInt(row.duration, 10) : 0}</td>
          </tr>
        </tbody>
      </Table>
    );
  }

  // 行の左に表示する開閉アイコン
  expandColumnComponent({ isExpandableRow, isExpanded }) {
    let content = '';

    if (isExpandableRow) {
      content = (isExpanded ? <FontAwesomeIcon size='1x' icon={faMinus} /> : <FontAwesomeIcon size='1x' icon={faPlus} />);
    } else {
      content = ' ';
    }
    return (
      <div id="test"> {content} </div>
    );
  }

  render() {
    const {t} = this.props;
    const ApiError = () => (
      <div>
        {(() => {
          if (!this.props.isTripList) {
            return (<Alert bsStyle="danger"><p>{t("Message." + msgs['msg_common_01'])}</p></Alert>)
          }
        })()}
      </div>
    )

    let tripListData = this.props.data;
    // もし空ならテーブルを表示しない
    if (tripListData.length === 0) {
      tripListData = undefined;
    }

    let options = {
      expandRowBgColor: '#cfece9',
      page: this.props.tripListPageNum,  // ページング位置初期化
      sortName: this.props.tripListSortName,
      sortOrder: this.props.tripListSortOrder,
      sizePerPage: 8,  // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 3,  // the pagination bar size.
      paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
      alwaysShowAllBtns: true,
      withFirstAndLast: true,
      hideSizePerPage: true,
      onPageChange: this.props.onTripListPageChange,
      onSortChange: this.props.onTripListSortChange,
      noDataText: 
        <Trans i18nKey="Message.NoTrip">
          Sorry, this vehicle has no trip yet.
        </Trans>
    }

    // 画面サイズに応じて表示ページ数を切り替える
    if (this.state.windowSize <= 992) {
      options['paginationSize'] = 3
    } else {
      options['paginationSize'] = 5
    }

      // スマホサイズの時は行拡張テーブル
      return (
        <div>
          <Row>
            <Col xs={12}>
              <ApiError />
            </Col>
          </Row>
          <Row>
            {
              <div>
                <Col xs={12}>
                  {this.props.tripListLoading ?
                  <Col md={12}>
                    <Panel>
                      <Loader />
                    </Panel>
                  </Col> :
                  <BootstrapTable
                    ref='table'
                    data={this.props.data}
                    pagination
                    options={options}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    expandColumnOptions={{
                      expandColumnVisible: true,
                      expandColumnComponent: this.expandColumnComponent,
                      columnWidth: 60
                    }}>
                    <TableHeaderColumn dataField="tripStartDate" dataSort={true} dataFormat={this.props.formatter} isKey dataAlign='center'>
                      {t('TripReport.StartTime')}
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="tripScore" dataSort={true} dataAlign='center'>
                      {t('Common.Score')}
                    </TableHeaderColumn>
                   </BootstrapTable>
                  }
                </Col>
              </div>
            }
          </Row>
        </div>
      );
  }
}



export default withTranslation()(TripListTable);



// WEBPACK FOOTER //
// ./src/component/TripReport/TripListTable.js